import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Scanner3dModel} from '../scanner3d.model';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {PermissionsConverter} from '../../../../../../common/converter/permissions.converter';

@Injectable()
export class Scanner3dConverter extends HttpModelConverter<Scanner3dModel>{
    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }
    protected createInstance(): Scanner3dModel {
        return new Scanner3dModel();
    }

    protected enrichObject(result: Scanner3dModel, src: Scanner3dModel) {
        result.defaultScanFormat = this.lovValueSummaryConverter.convert(src.defaultScanFormat);
        result.model = this.lovValueSummaryConverter.convert(src.model);
        result.type = this.lovValueSummaryConverter.convert(src.type);
        result.scanMethod = this.lovValueSummaryConverter.convert(src.scanMethod);
        result.permissions = new PermissionsConverter().convert(src.permissions);
    }
}
